const config = {};
config.baseURL = `https://${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_POSTFIX}`;
config.organizationID = process.env.REACT_APP_ORGANIZATION_ID;
config.telegramUrl = process.env.REACT_APP_TELEGRAM_URL;

export default Object.freeze(config);
